<template>
  <div class="footer-container">
    <div class="footer-content">
      <div class="footer-main">
        <div class="brand-section">
          <div class="logo-container">
            <img src="@/assets/i911-logo-2025.svg" alt="i911 Logo" class="logo"/>
          </div>
          <div class="brand-info">
            <p class="tagline">{{ $t('homepage.footer.tagline') }}</p>
            <div class="contact-links">
              <a href="tel:1-888-408-4911" class="contact-item">
                <span class="icon">📞</span>
                <span>1-888-408-4911</span>
              </a>
              <a href="mailto:hello@i911.com" class="contact-item">
                <span class="icon">✉️</span>
                <span>hello@i911.com</span>
              </a>
            </div>
          </div>
        </div>
        <div class="quick-links">
          <div class="link-group">
            <h4>{{ $t('homepage.footer.company') }}</h4>
            <div class="link-list">
              <a href="#" @click="goToAbout">{{ $t('homepage.footer.aboutUs') }}</a>
              <a href="#" @click="openDemoModal" class="contact-link">{{ $t('homepage.footer.contact') }}</a>
              <a href="https://www.indeed.com/cmp/I911/" target="_blank">{{ $t('homepage.footer.careers') }}</a>
              <!-- <a href="#">News</a> -->
            </div>
          </div>
          <div class="link-group">
            <h4>{{ $t('homepage.footer.support') }}</h4>
            <div class="link-list">
              <a href="https://i911help.zendesk.com/hc/en-us/requests/new" target="_blank">{{ $t('homepage.footer.support') }}</a>
              <!-- <a href="#">Documentation</a> -->
            </div>
          </div>
          <div class="link-group">
            <h4>{{ $t('homepage.footer.connect') }}</h4>
            <div class="link-list social-links">
              <a href="https://www.facebook.com/i911official" class="social-link" target="_blank">
                <span>{{ $t('homepage.footer.facebook') }}</span>
              </a>
              <a href="https://x.com/i911technology" class="social-link" target="_blank">
                <span>{{ $t('homepage.footer.twitter') }}</span>
              </a>
              <a href="https://www.linkedin.com/company/i911/posts/?feedView=all" class="social-link" target="_blank">
                <span>{{ $t('homepage.footer.linkedin') }}</span>
              </a>
              <a href="https://www.instagram.com/i911international/" class="social-link" target="_blank">
                <span>{{ $t('homepage.footer.instagram') }}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-bottom">
        <div class="bottom-content">
          <div class="copyright">
            <p>{{ $t('homepage.footer.copyright') }}</p>
          </div>
          <div class="bottom-links">
            <a href="#" @click="privacyPolicyModalActive = true">{{ $t('homepage.footer.privacy') }}</a>
            <PrivacyPolicyModal v-model="privacyPolicyModalActive" @accepted="accepted" class="footer-modal" style="padding-top: 10%;"/>
            <span class="separator">•</span>
            <a href="#" @click="tosModalActive = true">{{ $t('homepage.footer.terms') }}</a>
            <TosModal v-model="tosModalActive" @accepted="accepted" class="footer-modal" style="padding-top: 10%;"/>
            <!-- <span class="separator">•</span>
            <a href="#">Cookies</a> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import Vue from 'vue'
import PrivacyPolicyModal from '@/modals/PrivacyPolicyModal.vue'
import TosModal from '@/modals/TosModal.vue'

export default Vue.extend({
  data() {
    return {
      privacyPolicyModalActive: false,
      tosModalActive: false
    }
  },
  components: {
    PrivacyPolicyModal,
    TosModal
  },
  name: 'Footer',
  methods: {
    accepted() {
      // Handle acceptance logic if needed
    },
    openDemoModal() {
      this.$emit('openModal');
    },
    goToAbout() {
      if (this.$route.name != 'about') {
        this.$router.push('/about');
      }
    },
  }
})
</script>

<style scoped>
.footer-container {
  position: relative;
  width: 100%;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-top: 1px solid #e9ecef;
  box-shadow: 0 -8px 32px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  z-index: 10;
  min-height: auto;
}

.footer-content {
  max-width: 90%;
  margin: 0 auto;
  padding: 0 40px;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
}

.footer-main {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 80px;
  padding: 50px 0 40px;
  align-items: start;
}

img {
  width: 5.5rem;
}

.brand-section {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.tagline {
  color: #000000;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 18px;
  font-weight: 500;
  margin: 0;
  line-height: 1.3;
  letter-spacing: -0.02em;
}

.contact-links {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 8px;
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #000000;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  text-decoration: none;
  transition: all 0.3s ease;
  padding: 8px 0;
}

.contact-item:hover {
  color: #666;
  transform: translateX(4px);
}

.icon {
  font-size: 16px;
  opacity: 0.8;
}

.quick-links {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 150px;
}

.link-group h4 {
  color: #000000;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 20px 0;
  line-height: 1.2;
  letter-spacing: -0.025em;
  position: relative;
}

.link-group h4::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 24px;
  height: 2px;
  background: linear-gradient(90deg, #007bff, #0056b3);
  border-radius: 1px;
}

.link-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.link-list a {
  color: #000000;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  text-decoration: none;
  transition: all 0.3s ease;
  line-height: 1.2;
  letter-spacing: -0.025em;
  padding: 4px 0;
}

.link-list a:hover {
  color: #007bff;
  transform: translateX(4px);
}

.contact-link {
  cursor: pointer;
}

/* Ensure modals appear above navigation */
.footer-modal {
  z-index: 10000 !important;
}

.footer-modal .v-dialog {
  z-index: 10000 !important;
}

.footer-modal .v-overlay {
  z-index: 9999 !important;
}

.social-links {
  gap: 16px;
}

.social-link {
  display: flex;
  align-items: center;
  gap: 10px;
}

.social-icon {
  font-size: 18px;
  opacity: 0.7;
}

.footer-bottom {
  border-top: 1px solid #e9ecef;
  padding: 24px 0;
  background: #f8f9fa;
  position: relative;
  z-index: 1;
}

.bottom-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.copyright p {
  color: #000000;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  margin: 0;
  line-height: 1.2;
  letter-spacing: -0.025em;
}

.bottom-links {
  display: flex;
  align-items: center;
  gap: 16px;
}

.bottom-links a {
  color: #000000;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 14px;
  font-weight: 400;
  text-decoration: none;
  transition: color 0.3s ease;
}

.bottom-links a:hover {
  color: #007bff;
}

.separator {
  color: #d1d5db;
  font-size: 12px;
}

@media (max-width: 1024px) {
  .footer-main {
    gap: 60px;
  }
  
  .quick-links {
    gap: 30px;
  }
}

@media (max-width: 768px) {
  .footer-content {
    padding: 0 20px;
    width: 100%;
    box-sizing: border-box;
  }
  
  .footer-main {
    grid-template-columns: 1fr;
    gap: 40px;
    padding: 40px 0 30px;
  }
  
  .quick-links {
    grid-template-columns: repeat(2, 1fr);
    gap: 40px;
  }
  
  .bottom-content {
    flex-direction: column;
    gap: 16px;
    text-align: center;
  }
}

@media (max-width: 480px) {
  .footer-content {
    padding: 0 15px;
  }
  
  .footer-main {
    padding: 30px 0 20px;
  }
  
  .quick-links {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  
  .brand-section {
    text-align: center;
    align-items: center;
  }
  
  .contact-links {
    align-items: center;
  }
}
</style>

